import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Spinner from '../features/Spinner';
import { useSelector } from 'react-redux';

const RouteGuard = ({ children, membershipTypes = [] }) => {

    const { isAuthenticated, authLoading, user } = useSelector((state) => state.auth);
    const location = useLocation();

    console.log({
        user,
        isAuthenticated,
        membershipTypes,
    })

    if (authLoading) {
        return <Spinner fullscreen />;
    }

    if(!isAuthenticated || !user) {
        if (location.pathname !== '/login') {
            return <Navigate to="/login" replace state={{ from: location }} />;
        }
        //return <Navigate to="/login" replace />;
    }

    const userMembership = user?.membershipType?.[0]?.name;
    console.log("🛡 RouteGuard → user:", user);
    console.log("🛡 RouteGuard → userMembership:", userMembership);
    console.log("🛡 RouteGuard → allowed types:", membershipTypes);

    if (
        Array.isArray(membershipTypes) &&
        userMembership &&
        !membershipTypes.includes(userMembership)
    ) {
        console.warn("⛔ Membership not allowed, redirecting to /unauthorized");
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
}

export default RouteGuard;